import { CSSProperties } from "react";
import { PATH_ABOUT_SECTION } from "../../../utility/constants";
import { OurCoreValuesItemType } from "../../../utility/types/generaTypes";
import { OUR_CORE_VALUES } from "../../../utility/utilityData";
import Button from "../../common/buttons/button/Button";
import GradientIcon from "../gradientIcon/GradientIcon";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./AboutSection.css";
type AboutSectionProps = {
  style?: CSSProperties;
  isHomePage?: boolean;
};

const AboutSection = ({ style, isHomePage }: AboutSectionProps) => {
  return (
    <section id={PATH_ABOUT_SECTION} style={style}>
      <div className="app_section" style={{ gap: "3rem" }}>
        {isHomePage && (
          <div className="appSection_header_container">
            <SectionHeader title={`👥 About Us`} />
            <h1 className="section_title">
              Meet the <span className="gradient_text"> Creative Minds </span>
            </h1>
            <p className="section_description">
              We're a passionate team of developers, designers, and strategists
              dedicated to crafting exceptional digital experiences that make a
              lasting impact.
            </p>
          </div>
        )}
        <div className="about_section_content_container">
          <div className="about_content_leftContainer">
            <h2>Our Journey</h2>
            <p>
              JD SoftTech is a forward-thinking software development company
              from India, delivering innovative web and mobile solutions
              worldwide. We specialize in JavaScript technologies like React.js,
              Node.js, and React Native, tailored to diverse business needs.
              <br /> <br /> Our mission is to build high-quality, scalable
              applications that help businesses thrive in the digital era. With
              a strong focus on innovation, performance, and client
              satisfaction, we transform ideas into impactful
              products—partnering with startups and enterprises to create
              lasting value and success.
            </p>

            <Button
              title="Learn More About Our Process"
              onClickButton={() => {}}
              backgroundColor="linear-gradient(135deg, hsl(214 84% 56%), hsl(263 70% 50%))"
              className="learnMoreAboutBtn"
            />
          </div>
          <div className="about_content_rightContainer">
            <div className="circle_one" />
            <div className="about_content_rightSubContainer gradient_bg">
              <h3>4+</h3>
              <p className="yearExcellence_text">Years of Excellence</p>
              <p className="building_digital_text">
                Building digital solutions that matter
              </p>
            </div>
            <div className="circle_two" />
          </div>
        </div>
        <div className="ourCoreValues_container">
          <h3>Our Core Values</h3>
          <div className="ourCoreValuesCards_container">
            {OUR_CORE_VALUES.map((values, index) => (
              <OurValuesCard key={"OurValuesCard" + index} values={values} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
type OurValuesCardProps = {
  values: OurCoreValuesItemType;
};

const OurValuesCard = ({ values }: OurValuesCardProps) => {
  return (
    <div className="ourCoreValuesCard_container">
      <GradientIcon src={values?.icon} alt="core value" />
      <h4>{values?.title}</h4>
      <p>{values?.desc}</p>
    </div>
  );
};

export default AboutSection;
